<div class="pv-shell">
    <div class="container">

        <!-- CABEÇALHO DA TELA -->
        <div class="page-header no-print">
            <div class="page-header-icon" [style.background]="'rgba(255,255,255,0.15)'" [style.color]="'#fff'">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
            </div>
            <div style="flex: 1;">
                <h1>Relatório de Comissão de Vendas</h1>
                <p>Visualização de comissões por parceiro com base no recebimento financeiro.</p>
            </div>
            <div class="no-print" style="display: flex; gap: 10px;">
                <button type="button" class="btn-primario" *ngIf="dadosResultado && dadosResultado.length > 0" (click)="imprimirRelatorio()">
                    Imprimir Relatório
                </button>
            </div>
        </div>

        <!-- CARD DE FILTROS COM MODAL DE BUSCA ACOPLADO -->
        <div class="card no-print">
            <div class="card-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                </svg>
                Filtros do Relatório
            </div>

            <div class="form-grid relatorio-grid-custom">
                <div class="form-subgroup">
                    <label class="form-label">Data Inicial (Baixa)</label>
                    <input type="date" class="form-input" (ngModelChange)="aoMudarDataInicial($event)" [(ngModel)]="filtros.dataInicial">
                </div>

                <div class="form-subgroup">
                    <label class="form-label">Data Final (Baixa)</label>
                    <input type="date" class="form-input" [(ngModel)]="filtros.dataFinal">
                </div>

                <!-- CAMPO LARGO E ELEGANTE DE PARCEIRO COMISSIONADO -->
                <div class="form-subgroup">
                    <label class="form-label">Parceiro Comissionado (Opcional)</label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirModalParceiro()" title="Buscar Parceiro">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input"
                               [value]="filtros.codParc ? filtros.codParc + ' - ' + filtroParceiroTexto : 'Todos os Parceiros Comissionados'"
                               readonly
                               placeholder="Clique na lupa para buscar um parceiro específico...">
                        <button type="button" class="busca-combo-clear" *ngIf="filtros.codParc" (click)="limparParceiroSelecionado()" title="Limpar Seleção">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="form-subgroup actions-filter-group">
                    <div style="display: flex; gap: 8px;">
                        <button type="button" class="btn-primario" (click)="buscarRelatorioComissionamento()">
                            Consultar
                        </button>
                        <button type="button" class="btn-secundario" (click)="limparFiltrosTela()">
                            Limpar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- LOAD SPINNER -->
        <div *ngIf="carregando()" class="loading-overlay">
            <app-loading-indicator></app-loading-indicator>
        </div>

        <!-- TABELA DE RESULTADOS -->
        <div class="analitico-section" *ngIf="dadosResultado && dadosResultado.length > 0" style="margin-top: 24px; padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
            <div class="validity font-mono no-print">
                Descontos aplicados estritamente no nível dos itens. O cálculo da comissão deduz o Core proporcionalmente ao recebimento de cada parcela.
            </div>

            <div *ngFor="let grupo of dadosResultado" style="margin-bottom: 35px; page-break-inside: avoid;">
                <div style="background: #f1f5f9; padding: 10px 14px; font-size: 13px; font-weight: 700; color: #1e293b; border-bottom: 2px solid #cbd5e1; display: flex; gap: 20px;">
                    <span>Código: <span class="font-mono">{{ grupo.codParc }}</span></span>
                    <span>Comissionado: {{ grupo.nomeComissionado }}</span>
                </div>

                <table class="itens-table" style="width: 100%; border-collapse: collapse;">
                    <thead>
                    <tr style="background: #f8fafc; text-align: left;">
                        <th style="padding: 8px; width: 8%;">Finalização</th>
                        <th style="padding: 8px; width: 8%;">Receb.</th>
                        <th style="padding: 8px;">Nome do Cliente</th>
                        <th style="padding: 8px; width: 6%;">Prefixo</th>
                        <th style="padding: 8px; width: 10%;">Nº do Título</th>
                        <th style="padding: 8px; width: 5%;">Parc</th>
                        <th style="padding: 8px; width: 10%;">Condição</th>
                        <th style="padding: 8px; width: 9%; text-align: right;">Venda R$</th>
                        <th style="padding: 8px; width: 6%; text-align: right;">D.Itens %</th>
                        <th style="padding: 8px; width: 6%; text-align: right;">D.Geral %</th>
                        <th style="padding: 8px; width: 6%; text-align: right;">Venda %</th>
                        <th style="padding: 8px; width: 9%; text-align: right;">Recebido R$</th>
                        <th style="padding: 8px; width: 9%; text-align: right;">Comissão R$</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let venda of grupo.vendas; let par = even" [ngStyle]="{'background-color': par ? '#ffffff' : '#f8fafc'}" style="border-bottom: 1px solid #e2e8f0;">
                        <td style="padding: 8px;" class="font-mono">{{ venda.dtFinalizacao }}</td>
                        <td style="padding: 8px;" class="font-mono">{{ venda.dtRecebimento }}</td>
                        <td>{{ venda.nomeCliente }}</td>
                        <td style="padding: 8px;" class="font-mono">{{ venda.prefixo || '-' }}</td>
                        <td style="padding: 8px;" class="font-mono">{{ venda.numTitulo }}</td>
                        <td style="padding: 8px;" class="font-mono">{{ venda.parc }}</td>
                        <td>{{ venda.condicao }}</td>
                        <td style="padding: 8px; text-align: right;" class="font-mono">{{ formatarMoeda(venda.valorVendaBruto) }}</td>
                        <td style="padding: 8px; text-align: right; color: #ef4444;" class="font-mono">-{{ formatarPercentual(venda.percDescontoItens) }}</td>
                        <td style="padding: 8px; text-align: right;" class="font-mono">{{ formatarPercentual(venda.percDescontoGeral) }}</td>
                        <td style="padding: 8px; text-align: right;" class="font-mono">{{ formatarPercentual(venda.percVendaComissao) }}</td>
                        <td style="padding: 8px; text-align: right;" class="font-mono">{{ formatarMoeda(venda.valorRecebido) }}</td>
                        <td style="padding: 8px; text-align: right; font-weight: 700; color: #059669;" class="font-mono">{{ formatarMoeda(venda.valorComissao) }}</td>
                    </tr>
                    <tr style="background: #ffffff; font-weight: 700; border-top: 2px solid #cbd5e1;">
                        <td colspan="7" style="padding: 10px; text-align: right;"></td>
                        <td style="padding: 10px; text-align: right;" class="font-mono">{{ formatarMoeda(grupo.totalVenda) }}</td>
                        <td colspan="3" style="padding: 10px;"></td>
                        <td style="padding: 10px; text-align: right;" class="font-mono">{{ formatarMoeda(grupo.totalRecebido) }}</td>
                        <td style="padding: 10px; text-align: right; color: #059669;" class="font-mono">{{ formatarMoeda(grupo.totalComissao) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="quick-sale-empty no-print" *ngIf="(!dadosResultado || dadosResultado.length === 0) && !carregando()">
            {{ buscaMensagem }}
        </div>

    </div>
</div>

<!-- ======================================================================= -->
<!-- MODAL DE BUSCA COM DESFOQUE DE FUNDO (Padrão Estético Exclusivo) -->
<!-- ======================================================================= -->
<div class="modal-overlay" *ngIf="modalParceiroAberta">
    <div class="modal-box">
        <div class="modal-header">Buscar Parceiro Comissionado</div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input"
                   [(ngModel)]="filtroBuscaModal"
                   (input)="agendarBuscaParceirosModal()"
                   placeholder="Digite o nome, código ou documento..." autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let p of listaParceirosSugeridos()" (click)="selecionarParceiroModal(p)">
                    <div class="parceiro-item-titulo">{{ p.nomeparc }}</div>
                    <div class="parceiro-item-sub">Código: <strong>{{ p.codparc }}</strong> | Doc: {{ p.docparc || 'Não informado' }}</div>
                </div>
                <div class="busca-modal-empty" *ngIf="!listaParceirosSugeridos().length">
                    {{ statusBuscaParceiro }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharModalParceiro()">Fechar</button>
        </div>
    </div>
</div>